// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { CommentStreamCountDetailFragmentDoc } from '../../../../components/comments/CommentCountBubble.generated';
import { PotentialOperationDetailsFragmentDoc } from '../../../../queries/fragments.generated';
import { InternalUserDetailFragmentDoc } from '../../../../fragments/circularFragments.generated';
export type DraftScheduleTable_PlanTaskFragment = { __typename?: 'PlanTask', id: string, slackInDays?: number | null | undefined, simulationProbability: { __typename?: 'SimulationProbability', startDateBasisPoints?: number | null | undefined, endDateBasisPoints?: number | null | undefined, potentialStartDateBasisPoints?: Array<{ __typename?: 'PotentialDateBasisPoints', date: Types.Scalars['Date']['input'], basisPoints: number }> | null | undefined, potentialEndDateBasisPoints?: Array<{ __typename?: 'PotentialDateBasisPoints', date: Types.Scalars['Date']['input'], basisPoints: number }> | null | undefined }, streams: Array<{ __typename?: 'CommentStream', id: string, commentCount: number, unreadCount: number }>, committedTradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string }>, canSetTraderPartner: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type DraftScheduleTable_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> };

export type DraftScheduleTable_Project_Region_Fragment = { __typename?: 'Region', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> };

export type DraftScheduleTable_Project_Market_Fragment = { __typename?: 'Market', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> };

export type DraftScheduleTable_Project_Community_Fragment = { __typename?: 'Community', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> };

export type DraftScheduleTable_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> };

export type DraftScheduleTable_Project_Lot_Fragment = { __typename?: 'Lot', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> };

export type DraftScheduleTable_Project_Structure_Fragment = { __typename?: 'Structure', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> };

export type DraftScheduleTable_Project_Unit_Fragment = { __typename?: 'Unit', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', user?: { __typename?: 'InternalUser', id: string, name: string, avatar: string } | null | undefined }> };

export type DraftScheduleTable_ProjectFragment =
  | DraftScheduleTable_Project_StandaloneProject_Fragment
  | DraftScheduleTable_Project_Region_Fragment
  | DraftScheduleTable_Project_Market_Fragment
  | DraftScheduleTable_Project_Community_Fragment
  | DraftScheduleTable_Project_Subdivision_Fragment
  | DraftScheduleTable_Project_Lot_Fragment
  | DraftScheduleTable_Project_Structure_Fragment
  | DraftScheduleTable_Project_Unit_Fragment
;

export type PlanTaskSimulation_SimulationProbabilityFragment = { __typename?: 'SimulationProbability', startDateBasisPoints?: number | null | undefined, endDateBasisPoints?: number | null | undefined, potentialStartDateBasisPoints?: Array<{ __typename?: 'PotentialDateBasisPoints', date: Types.Scalars['Date']['input'], basisPoints: number }> | null | undefined, potentialEndDateBasisPoints?: Array<{ __typename?: 'PotentialDateBasisPoints', date: Types.Scalars['Date']['input'], basisPoints: number }> | null | undefined };

export const PlanTaskSimulation_SimulationProbabilityFragmentDoc = gql`
    fragment PlanTaskSimulation_SimulationProbability on SimulationProbability {
  startDateBasisPoints
  endDateBasisPoints
  potentialStartDateBasisPoints {
    date
    basisPoints
  }
  potentialEndDateBasisPoints {
    date
    basisPoints
  }
}
    `;
export const DraftScheduleTable_PlanTaskFragmentDoc = gql`
    fragment DraftScheduleTable_PlanTask on PlanTask {
  id
  slackInDays
  simulationProbability {
    ...PlanTaskSimulation_SimulationProbability
  }
  streams {
    ...CommentStreamCountDetail
  }
  committedTradePartners {
    id
    name
  }
  canSetTraderPartner {
    ...PotentialOperationDetails
  }
}
    ${PlanTaskSimulation_SimulationProbabilityFragmentDoc}
${CommentStreamCountDetailFragmentDoc}
${PotentialOperationDetailsFragmentDoc}`;
export const DraftScheduleTable_ProjectFragmentDoc = gql`
    fragment DraftScheduleTable_Project on Project {
  id
  teamMembers {
    user {
      ...InternalUserDetail
    }
  }
}
    ${InternalUserDetailFragmentDoc}`;